import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@tesla/ng-auth';

@Component({
  selector: 'app-session-invalid',
  templateUrl: './session-invalid.component.html',
  styleUrls: ['./session-invalid.component.scss']
})
export class SessionInvalidComponent implements OnInit {
  isRedirecting: boolean = false;
  constructor(
    private _router: Router
  ) { }

  ngOnInit(): void {
  }

  onAuthenticateWithMFA() {
    this.isRedirecting = true;
    this._router.navigate(['auth/mfa-enrollment/callback']);
  }
}
